module.exports = __webpack_public_path__ + "img/2.8781b4dc.png";